<section class="hearing-aid-container">
    <div class="container">
        <div class="row">
            <div class="ten no-padding-left">
                <h1 class="h2">Hearing Aid Compatibility</h1>
              <br>
            </div>
            <div class="twelve no-padding-left">
                <p>As wireless phones moved to digital with more features and improved efficiency, some digital phones may cause
                     interference for hearing aid users. To make sure the deaf and hard of hearing can use digital wireless devices,
                     the Federal Communications Commission (FCC) updated the Hearing Aid Compatibility Act of 1988 ("HAC Act"),
                     passing regulations to increase the number of hearing aid-compatible wireless devices.</p>
                <p> Learn more about hearing aid compatibility and wireless please go to: <a href="http://www.accesswireless.org"
                    target="_blank" rel="noreferrer">http://www.accesswireless.org</a></p>
            </div>
        </div>
        <div class="row">
            <div class="ten no-padding-left">
                <h2 class="h3">Compatible Phones and Devices</h2>
            </div>
            <div class="twelve no-padding-left">
                <p>Pursuant to FCC guidelines, the handsets features and details listed on the FreeUp Mobile website have been
                    tested and rated for Hearing Aid Compatibility (HAC). These HAC ratings, or "M-Ratings" and "T-Ratings,"
                    help hearing aid users find the best phone for their needs.</p>
            </div>
        </div>
        <div class="row">
            <div class="ten no-padding-left">
                <h2 class="h3">M-Ratings and Hearing Aid Immunity</h2>
            </div>
            <div class="twelve no-padding-left">
                <p>Phones with an M-Rating of M3 or M4 meet FCC requirements and are less likely to generate interference to
                    hearing devices than phones that are not labeled. M4 is the better/higher of the two ratings.</p>
                <p>Hearing devices may also be measured for immunity to this type of interference. Your hearing device manufacturer
                    or hearing health professional can help you find results for your hearing device. The more immune your
                    hearing aid is, the less likely you are to experience interference noise from mobile phones.</p>
            </div>
        </div>
        <div class="row">
            <div class="ten no-padding-left">
                <h2 class="h3">T-Ratings and Compatibility with Hearing Aids with Telecoils</h2>
            </div>
            <div class="twelve no-padding-left">
                <p>A telecoil is a small device that is built into some hearing aids for use with the telephone as well as assistive
                    listening devices. Not all hearing aids have telecoils. Phones with a T-Rating of T3 or T4 meet FCC requirements
                    and are more likely to work well for people who use hearing aids with telecoils with telephones. T4 is
                    the better/higher of the two ratings.</p>
            </div>
        </div>
        <div class="row">
            <div class="ten no-padding-left">
                <h2 class="h3">Options for the Deaf and Hard of Hearing</h2>
            </div>
            <div class="twelve no-padding-left margin-bottom-50">
                <p><strong>Text Messaging</strong></p>
                <p>Today's wireless devices are light, mobile, and packed with features to make writing easier. Some have full
                    QWERTY keyboards and almost all have predictive text for faster typing. BLUETOOTH® enabled phones, Speaker
                    Phones and wireless keyboards are also ideal for highvolume text with our unlimited plan and pay as you
                    go plans.
                </p>
            </div>
        </div>
    </div>
</section>
